export type Environment = {
	production: boolean;
	buildType: string;
	schoolOnboardApiRoot: string;
	server: Server | null;
	localizejs: {
		apiKey: string;
	};
	firebase: FirebaseConfig;
	websocket: WebSocketConfig;
};

export type WebSocketConfig = {
	urlMappings: {
		originalUrl: string;
		newUrl: string;
	}[];
};

export type Server = {
	api_root: string;
};

export type FirebaseConfig = {
	apiKey: string;
	authDomain: string;
	databaseURL: string;
	projectId: string;
	storageBucket: string;
	messagingSenderId: string;
	appId: string;
};

export const sharedWebsocketConfig = {
	urlMappings: [
		{
			originalUrl: 'wss://smartpass.app/api/staging/v1/long_polling',
			newUrl: 'wss://staging-ws.smartpass.app/api/staging/v1/long_polling',
		},
		{
			originalUrl: 'wss://smartpass.app/api/prod-us-central/v1/long_polling',
			newUrl: 'wss://ws.smartpass.app/api/prod-us-central/v1/long_polling',
		},
	],
};
